export const termLink =
  'https://comunicaciones.segurossura.com.co/SaludFinanciera/terminos_y_condiciones_salud_financiera.pdf'

export const privacyLink =
  'https://www.segurossura.com.co/Paginas/legal/politica-privacidad-datos.aspx'
